"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
exports.CSS = {
    container: 'c-FormDesigner',
    content: 'c-FormDesigner__content',
    header: 'c-FormDesigner__header',
    headerMsg: 'c0FormDesigner__header-message',
    field: {
        container: 'c-FormDesigner__fields',
    },
    info: {
        container: 'c-FormDesigner__info',
    },
    isEditing: 'c-FormDesigner--is-editing',
    isReadOnly: 'c-FormDesigner--is-read-only',
};
exports.Style = {
    [exports.CSS.container]: {
        display: 'flex',
        'flex-direction': 'column',
        width: '100%',
        height: '100%',
    },
    [exports.CSS.content]: {
        display: 'flex',
        overflow: 'hidden',
        flex: 1,
    },
    [exports.CSS.header]: {
        display: 'flex',
        'justify-content': 'space-between',
        'align-items': 'center',
    },
    [exports.CSS.headerMsg]: {
        display: 'inline-flex',
        alignItems: 'center',
    },
    [exports.CSS.field.container]: {
        'flex-direction': 'column',
        'overflow-y': 'auto',
        width: '300px',
    },
    [exports.CSS.info.container]: {
        flex: 1,
        'overflow-y': 'auto',
    },
};
//# sourceMappingURL=form.designer.style.js.map